import styled from '@emotion/styled';

export const ListContainer = styled.div`
  flex-grow: 1;

  & > .item {
    max-height: 150px;
  }
`;
